// import React, { useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { Row, Col, Tab, Tabs } from "react-bootstrap";
// import moment from "moment";
// import { Field, FieldArray, Formik, useFormikContext } from "formik";
// import DatePicker from "react-datepicker";
// import Clock from "../../assets/img/clock.svg";
// import Calendar from "../../assets/img/calendar-color.svg";
// import Meeting from "../../assets/img/meetingWith.png";
// import Select from "react-select";

// import StatusCheck from "../../assets/img/status-check.svg";
// import EditIcon from "../../assets/img/edit-icon.svg";
// import Question from "../../assets/img/question-mark.svg";
// import Ellipse from "../../assets/img/ellipse-1.svg";
// import { toast } from "react-toastify";
// import ErrorComponent from "../../Component/ErrorComponent";
// import DELETE from "../../assets/img/delete-icon.svg";
// import ADD from "../../assets/img/add.svg";
// import {
//   CreateAssignemntSchema,
//   Elibrary,
//   validationSchemas,
//   validationSchemasMul,
// } from "../../utils/ValidationSchema";
// import SelectStarModal from "../../Component/SelectStar";
// import { useEffect } from "react";
// import {
//   GetFunction,
//   SubmitResponse,
//   UpdatePutReponse,
//   handleimageUrl,
// } from "../../utils/ApiFunctions";
// import { useLocalization } from "../../Component/Localization/Localization";
// import { init } from "emoji-mart";
// // import SelectStar from "../Component/SelectStar"

// const AddQuestions = () => {
//   const { assessmentType, id, assignment, value } = useParams();
//   const navigate = useNavigate();
//   const [previousQuestions, SetpreviousQuestion] = useState([]);

//   const [preview, setImagePreivew] = useState("");
//   const [valuesType, setMAinType] = useState("");
//   const [dataforShow, setDataForShow] = useState([]);
//   const [questions, setQuestions] = useState([]);
//   const usr = localStorage.getItem("user_id");

//   const [shoedataaftersave, setShowData] = useState(false);
//   const [starmodal, setSlectStarModal] = useState([]);
//   const [alldata, setAllData] = useState(false);
//   const [subType, setSubType] = useState("");
//   const [stararraySelected, SetSelectStar] = useState([]);

//   const [initialValues1, setIntinalValues1] = useState({
//     type: "",
//     subtype: "",
//     marks: "",
//     title: "",
//     mediaFile: "",
//     description: "",
//     answer: "",
//     answerOption: "",
//     options: ["", "", "", ""],
//     mulipleansweroption: [],
//   });
//   const questionsType = [
//     { value: "writtenQuestion", label: "Written Question" },
//     { value: "photoWithQuestion", label: "Photo With Question" },
//     { value: "videoWithQuestion", label: "Video With Question" },
//     { value: "voiceOnly", label: "Voice only" },
//     // { value: "match", label: "Match" },
//     { value: "multipleChooseOnAnswer", label: "Multiple choose on answer" },
//     {
//       value: "multipleChooseMoreThanOneCorrectAnswer",
//       label: "Multiple choose more than one correct answer",
//     },
//     { value: "sequenceMultipleChoose", label: "Sequence Multiple Choose" },
//     { value: "completeTheSentence", label: "Complete The Sentence" },
//     { value: "completeTheWord", label: "Complete The Word" },
//   ];

//   async function GetDetails() {
//     const res = await GetFunction(`assignments/single/${assignment}`);
//     if (res.status == 200) {
//       setQuestions(res?.data?.data?.questions);
//       setDataForShow(res?.data?.data);
//     }
//   }

//   // setQuestiion in array

//   useEffect(() => {
//     if (questions && questions.length > 0) {
//       const firstQuestion = questions?.[0];

//       const optionsObj = [
//         ...Object.values(questions?.[0]?.option1),
//         ...Object.values(questions?.[0]?.option2),
//         ...Object.values(questions?.[0]?.option3),
//         ...Object.values(questions?.[0].option4),
//         ...Object.values(questions?.[0].option5),
//         ...Object.values(questions?.[0].option6),
//       ];
//       setImagePreivew(handleimageUrl(firstQuestion?.mediaFile));

//       setIntinalValues1({
//         type: firstQuestion?.type,
//         subtype: firstQuestion?.subtype,
//         marks: firstQuestion?.marks,
//         title: firstQuestion?.title,
//         mediaFile: firstQuestion?.mediaFile,
//         description: firstQuestion?.description,
//         answer: firstQuestion?.answer?.text,
//         answerOption: firstQuestion?.answer?.option,
//         options: optionsObj,
//         mulipleansweroption: firstQuestion?.answer?.multiOption,
//         id: firstQuestion?._id,
//         questionsNo: firstQuestion?.questionNo,
//       });

//       //   setQuestions((pre) => pre?.splice(0, 1));
//     } else {
//       setIntinalValues1({
//         type: "",
//         subtype: "",
//         marks: "",
//         title: "",
//         mediaFile: "",
//         description: "",
//         answer: "",
//         answerOption: "",
//         options: ["", "", "", ""],
//         mulipleansweroption: [],
//       });
//     }
//   }, [questions]);

//   useEffect(() => {
//     if (assignment) {
//       GetDetails();
//     }
//   }, [assignment]);

//   useEffect(() => {
//     if (shoedataaftersave) {
//       GetDetails();
//     }
//   }, [shoedataaftersave]);

//   const onSubmitFunction1 = async (values, { resetForm }) => {
//     const data = new FormData();

//     if (values?.id) {
//       data.append("id", values?.id);
//     }
//     data.append("assignment", assignment);
//     data.append("title", values?.title);
//     data.append("description", values?.description);
//     // if (assessmentType == "worksheet" || assessmentType == "awarenessCourses" ) {
//     //   data.append("marks", 0);
//     // } else {
//     //   data.append("marks", values?.marks);
//     // }
//     data.append("marks", values?.marks);
//     if (values?.answer) {
//       data.append("answer", values?.answer);
//     }
//     data.append("type", values?.type);
//     data.append("subtype", values?.subtype);
//     if (values?.mediaFile) {
//       if (values.mediaFile instanceof File) {
//         data.append("mediaFile", values?.mediaFile);
//       }
//     }
//     if (values?.answerOption) {
//       data.append("answerOption", values?.answerOption);
//     }
//     let Optiosn = [];

//     if (
//       values?.options &&
//       values?.options.every(
//         (element) => typeof element === "string" && element !== ""
//       )
//     ) {
//       if (values?.options) {
//         for (let i = 0; i < values?.options?.length; i++) {
//           data.append(`option${i + 1}`, values?.options[i]);
//           // if (values?.mulipleansweroption?.includes(values?.options[i])) {
//           //   Optiosn.push(`option${i + 1}`);
//           // }
//         }
//       }
//       // Optiosn = Optiosn?.flat();
//     }

//     // if (Optiosn) {
//     //   for (let i = 0; i < Optiosn?.length; i++) {
//     //     data.append(`multiOption[${i}]`, Optiosn[i]);
//     //   }
//     // }
//     if (values?.mulipleansweroption) {
//       for (let i = 0; i < values?.mulipleansweroption?.length; i++) {
//         data.append(`multiOption[${i}]`, values?.mulipleansweroption[i]);
//       }
//     }

//     const res = await SubmitResponse(`/assignments/add_question`, data);
//     if (res.status == 200) {
//       toast.dismiss();

//       toast.success(res?.data?.message);

//       if (value == "1") {
//         const updatedArray = questions.slice(1);
//         setQuestions(updatedArray);
//         resetForm();
//         SetpreviousQuestion((pre) => [...pre, res?.data?.data]); //for back questiuonas
//         setImagePreivew("");
//       } else {
//         resetForm();
//         SetpreviousQuestion((pre) => [...pre, res?.data?.data]); //for back questiuonas
//         setImagePreivew("");
//         const updatedArray = questions.slice(1);
//         setQuestions(updatedArray);
//       }
//     }
//   };

//   const onSubmitFunction2 = async (values, { resetForm }) => {
//     const data = new FormData();
//     if (value == "1" && values?.id) {
//       data.append("id", values?.id);
//     }
//     data.append("assignment", assignment);
//     data.append("title", values?.title);
//     data.append("description", values?.description);
//     data.append("marks", values?.marks);
//     if (values?.answer) {
//       data.append("answer", values?.answer);
//     }
//     data.append("type", values?.type);
//     data.append("subtype", values?.subtype);
//     if (values?.mediaFile) {
//       if (values.mediaFile instanceof File) {
//         data.append("mediaFile", values?.mediaFile);
//       }
//     }
//     if (values?.answerOption) {
//       data.append("answerOption", values?.answerOption);
//     }

//     // if (
//     //   values?.options &&
//     //   values?.options.every(
//     //     (element) => typeof element === "string" && element !== ""
//     //   )
//     // ) {
//     //   if (values?.options) {
//     //     for (let i = 0; i < values?.options?.length; i++) {
//     //       data.append(`option${i + 1}`, values?.options[i]);
//     //     }
//     //   }
//     // }

//     if (values?.mulipleansweroption) {
//       for (let i = 0; i < values?.mulipleansweroption?.length; i++) {
//         data.append(`multiOption[${i}]`, values?.mulipleansweroption[i]);
//       }
//     }

//     let Optiosn = [];

//     if (
//       values?.options &&
//       values?.options.every(
//         (element) => typeof element === "string" && element !== ""
//       )
//     ) {
//       if (values?.options) {
//         for (let i = 0; i < values?.options?.length; i++) {
//           data.append(`option${i + 1}`, values?.options[i]);
//           // if (values?.mulipleansweroption?.includes(values?.options[i])) {
//           //   Optiosn.push(`option${i + 1}`);
//           // }
//         }
//       }
//       // Optiosn = Optiosn?.flat();
//     }

//     // if (Optiosn) {
//     //   for (let i = 0; i < Optiosn?.length; i++) {
//     //     data.append(`multiOption[${i}]`, Optiosn[i]);
//     //   }
//     // }

//     const res = await SubmitResponse(`/assignments/add_question`, data);
//     if (res.status == 200) {
//       toast.dismiss();
//       setAllData(values);
//       setShowData(true);
//       toast.success(res?.data?.message);
//       setImagePreivew("");
//       resetForm();
//       // navigate(`/elibrary/${assessmentType}`);
//     }
//   };

//   const onSubmitFunction3 = async () => {
//     // getPreviosQuestion and update

//     const firstQuestion = previousQuestions[previousQuestions?.length - 1];

//     const optionsObj = [
//       ...Object.values(firstQuestion?.option1 ? firstQuestion?.option1 : ""),
//       ...Object.values(firstQuestion.option2 ? firstQuestion.option2 : ""),
//       ...Object.values(firstQuestion.option3 ? firstQuestion.option3 : ""),
//       ...Object.values(firstQuestion.option4 ? firstQuestion.option4 : ""),
//       ...Object.values(firstQuestion.option5 ? firstQuestion.option5 : ""),
//       ...Object.values(firstQuestion.option6 ? firstQuestion.option6 : ""),
//     ];
//     setImagePreivew(handleimageUrl(firstQuestion?.mediaFile));
//     setIntinalValues1({
//       type: firstQuestion?.type,
//       subtype: firstQuestion?.subtype,
//       marks: firstQuestion?.marks,
//       title: firstQuestion?.title,
//       mediaFile: firstQuestion?.mediaFile,
//       description: firstQuestion?.description,
//       answer: firstQuestion?.answer?.text,
//       answerOption: firstQuestion?.answer?.option,
//       options: optionsObj,
//       mulipleansweroption: firstQuestion?.answer?.multiOption,
//       id: firstQuestion?._id,
//     });
//     const remaining = previousQuestions.slice(0, -1);
//     SetpreviousQuestion(remaining);
//   };

//   const { t } = useLocalization();
//   // for last View

//   const SaveData = async (type) => {
//     const bools = type == "mySelf" ? false : true;
//     const res = await GetFunction(
//       `assignments/post/${assignment}?isPost=${bools}`
//     );
//     if (res.status == 200) {
//       toast.dismiss();

//       toast.success(res?.data?.message);
//       navigate(`/elibrary/${assessmentType}`);
//     }
//   };

//   const subTypeOptions = [
//     { value: "", label: `${t("sub_type")}:` },
//     ...(valuesType === "writtenQuestion" ||
//     valuesType === "photoWithQuestion" ||
//     valuesType === "videoWithQuestion" ||
//     valuesType === "voiceOnly"
//       ? [
//           { value: "subjective", label: "Subjective" },
//           { value: "objective", label: "Objective" },
//           { value: "multipleSelect", label: "MultipleSelect" },
//         ]
//       : valuesType === "match" || valuesType === "multipleChooseOnAnswer"
//       ? [
//           { value: "objective", label: "Objective" },
//           { value: "multipleSelect", label: "MultipleSelect" },
//         ]
//       : valuesType === "multipleChooseMoreThanOneCorrectAnswer"
//       ? [{ value: "multipleSelect", label: "MultipleSelect" }]
//       : valuesType === "sequenceMultipleChoose"
//       ? [{ value: "objective", label: "Objective" }]
//       : valuesType === "completeTheWord" || valuesType === "completeTheSentence"
//       ? [
//           { value: "objective", label: "Objective" },
//           { value: "subjective", label: "Subjective" },
//         ]
//       : [
//           { value: "objective", label: "Objective" },
//           { value: "subjective", label: "Subjective" },
//           { value: "multipleSelect", label: "MultipleSelect" },
//         ]),
//   ];

//   return (
//     <>
//       <div id="main" className="main-section-login">
//         <section className="">
//           <div className="section-heading plage-steps-dtl my-2">
//             <h2 className="performance-heading">
//               {id ? t("update_question") : t("add_question")}
//               <span></span>
//             </h2>
//           </div>

//           <section className="profile-aection bg-light p-4">
//             <Row className="mt-2">
//               <div>
//                 {value == "1" && !shoedataaftersave ? (
//                   <span>
//                     {initialValues1?.questionsNo
//                       ? "Question No:" + initialValues1?.questionsNo
//                       : ""}
//                   </span>
//                 ) : (
//                   ""
//                 )}
//               </div>
//               {!shoedataaftersave && (
//                 <Col md={8}>
//                   <Formik
//                     initialValues={initialValues1}
//                     onSubmit={(values, { resetForm }) => {
//                       if (values.buttonClicked === "saveAndNext") {
//                         onSubmitFunction1(values, { resetForm });
//                       } else if (values.buttonClicked === "post") {
//                         onSubmitFunction2(values, { resetForm });
//                       } else if (values.buttonClicked === "PreviousQuestion") {
//                         // onSubmitFunction3(values, { resetForm });
//                       }
//                     }}
//                     //   onSubmit={id ? UpdateSubmit : handleSubmit}
//                     validationSchema={
//                       !value || value == undefined
//                         ? subType == "objective" ||
//                           (subType == "multipleSelect" && assignment !== "")
//                           ? validationSchemasMul
//                           : validationSchemas
//                         : ""
//                     }
//                     enableReinitialize
//                   >
//                     {({
//                       values,
//                       errors,
//                       touched,
//                       handleChange,
//                       setFieldValue,
//                       handleBlur,
//                       handleSubmit,
//                       isSubmitting,
//                       resetForm,
//                     }) => (
//                       <form
//                         className="cmn-frm without-icon add-filds"
//                         onSubmit={handleSubmit}
//                       >
//                         <Row>
//                           <Col md={12}>
//                             <div className="form-group upper-index-1">
//                               {/* <select
//                                 onChange={handleChange}
//                                 value={values.type}
//                                 name="type"
//                               >
//                                 <option value="" defaultValue>
//                                   {t("select_question")}
//                                 </option>
//                                 {questionsType &&
//                                   questionsType?.map((val, i) => (
//                                     <option value={val?.value}>
//                                       {val?.name}
//                                     </option>
//                                   ))}
//                               </select> */}

//                               <Select
//                                 placeholder={t("select_question")}
//                                 options={questionsType}
//                                 onChange={(option) => {
//                                   setMAinType(option.value);
//                                   setSubType("");
//                                   setFieldValue("mediaFile", "");
//                                   setFieldValue("subtype", "");
//                                   setImagePreivew("");
//                                   handleChange({
//                                     target: {
//                                       name: "type",
//                                       value: option ? option.value : "",
//                                     },
//                                   });
//                                 }}
//                                 styles={{
//                                   menuPortal: (base) => ({
//                                     ...base,
//                                     zIndex: 9999, // Set the desired z-index value
//                                     padding: "5px",
//                                   }),
//                                   control: (provided) => ({
//                                     ...provided,
//                                     borderColor: "#AEAEAE", // Set border color to #AEAEAE
//                                     "&:hover": {
//                                       borderColor: "#AEAEAE", // Set border color when hovering
//                                     },
//                                     padding: "8px",
//                                   }),
//                                 }}
//                                 value={questionsType.find(
//                                   (option) => option.value === values.type
//                                 )}
//                               />
//                             </div>
//                             <ErrorComponent
//                               error={errors.type && touched.type && errors.type}
//                             />
//                           </Col>

//                           <Col md={12}>
//                             <div className="form-group upper-index">
//                               {/* <select
//                                 onChange={(e) => {
//                                   handleChange(e);
//                                   setSubType(e.target.value);
//                                   setFieldValue("mediaFile", "");
//                                   setImagePreivew("");
//                                 }}
//                                 value={values.subtype}
//                                 name="subtype"
//                               >
//                                 <option value="" defaultValue>
//                                   {t("sub_type")}:
//                                 </option>

//                                 {values?.type == "writtenQuestion" ||
//                                 values?.type == "photoWithQuestion" ||
//                                 values?.type == "videoWithQuestion" ||
//                                 values?.type == "voiceOnly" ? (
//                                   <>
//                                     <option value="subjective">
//                                       Subjective
//                                     </option>
//                                     <option value="objective">Objective</option>
//                                     <option value="multipleSelect">
//                                       MultipleSelect
//                                     </option>
//                                   </>
//                                 ) : values?.type == "match" ||
//                                   values?.type == "multipleChooseOnAnswer" ? (
//                                   <>
//                                     <option value="objective">Objective</option>
//                                     <option value="multipleSelect">
//                                       MultipleSelect
//                                     </option>
//                                   </>
//                                 ) : values?.type ==
//                                   "multipleChooseMoreThanOneCorrectAnswer" ? (
//                                   <>
//                                     <option value="multipleSelect">
//                                       MultipleSelect
//                                     </option>
//                                   </>
//                                 ) : values?.type == "sequenceMultipleChoose" ? (
//                                   <>
//                                     <option value="objective">Objective</option>
//                                   </>
//                                 ) : values?.type == "completeTheWord" ||
//                                   values?.type == "completeTheSentence" ? (
//                                   <>
//                                     <option value="objective">Objective</option>
//                                     <option value="subjective">
//                                       Subjective
//                                     </option>
//                                   </>
//                                 ) : (
//                                   <>
//                                     <option value="objective">Objective</option>
//                                     <option value="subjective">
//                                       Subjective
//                                     </option>
//                                     <option value="multipleSelect">
//                                       MultipleSelect
//                                     </option>
//                                   </>
//                                 )}
//                               </select> */}
//                               <Select
//                                 placeholder={t("sub_type")}
//                                 options={subTypeOptions}
//                                 onChange={(option) => {
//                                   setSubType(option.value);
//                                   setFieldValue("mediaFile", "");
//                                   setImagePreivew("");
//                                   handleChange({
//                                     target: {
//                                       name: "subtype",
//                                       value: option ? option.value : "",
//                                     },
//                                   });
//                                 }}
//                                 styles={{
//                                   menuPortal: (base) => ({
//                                     ...base,
//                                     zIndex: 9999, // Set the desired z-index value
//                                     padding: "5px",
//                                   }),
//                                   control: (provided) => ({
//                                     ...provided,
//                                     borderColor: "#AEAEAE", // Set border color to #AEAEAE
//                                     "&:hover": {
//                                       borderColor: "#AEAEAE", // Set border color when hovering
//                                     },
//                                     padding: "8px",
//                                   }),
//                                 }}
//                                 value={subTypeOptions.find(
//                                   (option) => option.value === values.subtype
//                                 )}
//                               />
//                             </div>
//                             <ErrorComponent
//                               error={
//                                 errors.subtype &&
//                                 touched.subtype &&
//                                 errors.subtype
//                               }
//                             />
//                           </Col>

//                           {
//                             // assessmentType != "awarenessCourses" &&
//                             //   assessmentType != "worksheet" &&
//                             <Col md={12}>
//                               <div className="form-group">
//                                 <input
//                                   type="number"
//                                   required
//                                   name="marks"
//                                   placeholder={t("marks")}
//                                   onChange={handleChange}
//                                   value={values.marks}
//                                 />
//                               </div>
//                               <ErrorComponent
//                                 error={
//                                   errors.marks && touched.marks && errors.marks
//                                 }
//                               />
//                             </Col>
//                           }

//                           <Col md={12}>
//                             <div className="form-group">
//                               <input
//                                 type="text"
//                                 name="title"
//                                 placeholder={t("title")}
//                                 onChange={handleChange}
//                                 value={values.title}
//                               />
//                             </div>
//                             <ErrorComponent
//                               error={
//                                 errors.title && touched.title && errors.title
//                               }
//                             />
//                           </Col>

//                           {(values?.subtype == "multipleSelect" ||
//                             values?.subtype == "objective") && (
//                             <FieldArray name="options ">
//                               {({ push, remove }) => (
//                                 <div>
//                                   {values.options.map((item, index) => (
//                                     <>
//                                       <div
//                                         key={index}
//                                         className="d-flex mt-2 mb-2"
//                                       >
//                                         <Field
//                                           name={`options[${index}]`}
//                                           placeholder={`Enter option ${
//                                             index + 1
//                                           }`}
//                                         />
//                                         {}

//                                         {values?.options?.length > 2 && (
//                                           <button
//                                             className="form-delete-btn mx-2"
//                                             type="button"
//                                           >
//                                             <img
//                                               src={DELETE}
//                                               onClick={() => {
//                                                 // remove(index);
//                                                 const newOptions = [
//                                                   ...values.options,
//                                                 ]; // Create a copy of the array
//                                                 newOptions.splice(index, 1); // Remove the item at the specified index
//                                                 setFieldValue(
//                                                   "options",
//                                                   newOptions
//                                                 );
//                                               }}
//                                             />
//                                           </button>
//                                         )}
//                                       </div>
//                                       <ErrorComponent
//                                         error={
//                                           errors.options &&
//                                           touched.options?.[index] &&
//                                           errors.options?.[index]
//                                         }
//                                       />
//                                     </>
//                                   ))}

//                                   {values?.options?.length < 6 && (
//                                     <button
//                                       type="button"
//                                       className="form-delete-btn"
//                                       // onClick={() => push("")}//
//                                     >
//                                       <img
//                                         src={ADD}
//                                         onClick={() => {
//                                           const newOptions = [
//                                             ...values.options,
//                                           ]; // Create a copy of the array
//                                           newOptions.push(""); // Remove the item at the specified index
//                                           setFieldValue("options", newOptions);
//                                         }}
//                                       />
//                                     </button>
//                                   )}
//                                 </div>
//                               )}
//                             </FieldArray>
//                           )}

//                           {values?.type == "photoWithQuestion" ||
//                           values?.type == "voiceOnly" ||
//                           values?.type == "videoWithQuestion" ? (
//                             <Col md={12}>
//                               <div className="form-group">
//                                 <input
//                                   type="file"
//                                   className={
//                                     values?.type == "voiceOnly"
//                                       ? "form-group voice"
//                                       : "form-group"
//                                   }
//                                   // required
//                                   onChange={(e) => {
//                                     if (values.type == "photoWithQuestion") {
//                                       if (
//                                         e.target.files[0]?.type.startsWith(
//                                           "image"
//                                         )
//                                       ) {
//                                         setFieldValue(
//                                           "mediaFile",
//                                           e.target.files[0]
//                                         );
//                                         setImagePreivew(
//                                           URL.createObjectURL(e.target.files[0])
//                                         );
//                                       } else {
//                                         toast.error(
//                                           "Please Select Image In Photo Type Question"
//                                         );
//                                       }
//                                     }

//                                     if (values.type == "voiceOnly") {
//                                       if (
//                                         e.target.files[0]?.type.startsWith(
//                                           "audio"
//                                         )
//                                       ) {
//                                         setFieldValue(
//                                           "mediaFile",
//                                           e.target.files[0]
//                                         );
//                                         setImagePreivew(
//                                           URL.createObjectURL(e.target.files[0])
//                                         );
//                                       } else {
//                                         toast.error(
//                                           "Please Select Audio File In Voice Type Question"
//                                         );
//                                       }
//                                     }

//                                     if (values.type == "videoWithQuestion") {
//                                       if (
//                                         e.target.files[0]?.type.startsWith(
//                                           "video"
//                                         )
//                                       ) {
//                                         setFieldValue(
//                                           "mediaFile",
//                                           e.target.files[0]
//                                         );
//                                         setImagePreivew(
//                                           URL.createObjectURL(e.target.files[0])
//                                         );
//                                       } else {
//                                         toast.error(
//                                           "Please Select video In Video Type Question"
//                                         );
//                                       }
//                                     }
//                                   }}
//                                 />
//                               </div>

//                               <ErrorComponent
//                                 error={
//                                   errors.mediaFile &&
//                                   touched.mediaFile &&
//                                   errors.mediaFile
//                                 }
//                               />
//                               {preview !== "" && (
//                                 <div className="delete-icon-image">
//                                   {values.type == "photoWithQuestion" ? (
//                                     <img src={preview} className="img-fluid" />
//                                   ) : (
//                                     <iframe
//                                       width="560"
//                                       height="315"
//                                       frameBorder="0"
//                                       allowFullScreen
//                                       src={preview}
//                                       className="img-fluid"
//                                     />
//                                   )}
//                                   <div
//                                     className={
//                                       values.type == "photoWithQuestion"
//                                         ? "delete-ic cursors"
//                                         : "delete-icon cursors"
//                                     }
//                                   >
//                                     <img
//                                       src={DELETE}
//                                       onClick={(e) => {
//                                         e.preventDefault();
//                                         setFieldValue("mediaFile", "");
//                                         setImagePreivew("");
//                                       }}
//                                     />
//                                   </div>
//                                 </div>
//                               )}
//                             </Col>
//                           ) : (
//                             ""
//                           )}

//                           <Col md={12}>
//                             <div className="form-group">
//                               <textarea
//                                 className="form-control"
//                                 onChange={handleChange}
//                                 name="description"
//                                 value={values?.description}
//                                 placeholder={t("description")}
//                                 rows={5}
//                               />
//                             </div>
//                             <ErrorComponent
//                               error={
//                                 errors.description &&
//                                 touched.description &&
//                                 errors.description
//                               }
//                             />
//                           </Col>

//                           {values?.subtype == "subjective" ? (
//                             <Col md={12}>
//                               <div className="form-group">
//                                 <input
//                                   type="text"
//                                   name="answer"
//                                   placeholder="Answer"
//                                   onChange={handleChange}
//                                   value={values.answer}
//                                   required
//                                 />
//                               </div>
//                               <ErrorComponent
//                                 error={
//                                   errors.answer &&
//                                   touched.answer &&
//                                   errors.answer
//                                 }
//                               />
//                             </Col>
//                           ) : values?.subtype == "objective" ? (
//                             <>
//                               <div className="form-group">
//                                 <select
//                                   onChange={handleChange}
//                                   value={values.answerOption}
//                                   name="answerOption"
//                                 >
//                                   <option value="" defaultValue>
//                                     Select Answer
//                                   </option>
//                                   {values?.options &&
//                                     values?.options?.map((val, i) => (
//                                       <option value={`option${[i + 1]}`}>
//                                         {val}
//                                       </option>
//                                     ))}
//                                 </select>
//                               </div>
//                               <ErrorComponent
//                                 error={
//                                   errors.answerOption &&
//                                   touched.answerOption &&
//                                   errors.answerOption
//                                 }
//                               />
//                             </>
//                           ) : values?.subtype == "multipleSelect" &&
//                             values?.options.every(
//                               (element) =>
//                                 typeof element === "string" && element !== ""
//                             ) ? (
//                             <>
//                               <div className="muliple answer">
//                                 <h5>{t("select_multiple_answer")}</h5>
//                                 <FieldArray name="mulipleansweroption">
//                                   {({ push, remove }) => (
//                                     <div>
//                                       {values?.options?.map((option, index) => (
//                                         <div key={index}>
//                                           <label>
//                                             <Field
//                                               type="checkbox"
//                                               name={`mulipleansweroption[${
//                                                 index + 1
//                                               }]`}
//                                               value={option}
//                                               checked={values?.mulipleansweroption?.includes(
//                                                 `option${index + 1}`
//                                               )}
//                                               // onChange={(e) => {
//                                               //   const { value, checked } =
//                                               //     e.target;

//                                               //   if (checked) {
//                                               //     push(value);
//                                               //   } else {
//                                               //     const idx =
//                                               //       values.mulipleansweroption.indexOf(
//                                               //         value
//                                               //       );
//                                               //     if (idx !== -1) {
//                                               //       remove(idx);
//                                               //     }
//                                               //   }
//                                               // }}

//                                               onChange={(e) => {
//                                                 const { value, checked } =
//                                                   e.target;

//                                                 if (checked) {
//                                                   // push(value);
//                                                   push(`option${index + 1}`);
//                                                 } else {
//                                                   const idx =
//                                                     values?.mulipleansweroption?.findIndex(
//                                                       // (item) => item == value
//                                                       (item) =>
//                                                         item ==
//                                                         `option${index + 1}`
//                                                       // `option${index + 1}`
//                                                     );
//                                                   if (idx !== -1) {
//                                                     remove(idx);
//                                                   }
//                                                 }
//                                               }}
//                                             />
//                                             {option}
//                                           </label>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   )}
//                                 </FieldArray>
//                                 <ErrorComponent
//                                   error={
//                                     errors.mulipleansweroption &&
//                                     touched.mulipleansweroption &&
//                                     errors.mulipleansweroption
//                                   }
//                                 />
//                               </div>
//                             </>
//                           ) : (
//                             ""
//                           )}

//                           {previousQuestions.length > 0 && (
//                             <Col md={4}>
//                               <div>
//                                 <button
//                                   className="btn-btn-primary px-3 w-100 text-nowrap"
//                                   type="button"
//                                   onClick={() => onSubmitFunction3()}
//                                 >
//                                   {t("PreviousQuestion")}
//                                 </button>
//                               </div>
//                             </Col>
//                           )}
//                           <Col md={4}>
//                             <div>
//                               <button
//                                 className="btn-btn-primary px-3 w-100 text-nowrap"
//                                 type="submit"
//                                 onClick={() =>
//                                   setFieldValue("buttonClicked", "saveAndNext")
//                                 }
//                               >
//                                 {t("save_next")}
//                               </button>
//                             </div>
//                           </Col>

//                           <Col md={4}>
//                             <div>
//                               <button
//                                 className={
//                                   previousQuestions?.length > 0
//                                     ? "btn-btn-primary px-5"
//                                     : "btn-btn-primary px-5"
//                                 }
//                                 type="submit"
//                                 onClick={() =>
//                                   setFieldValue("buttonClicked", "post")
//                                 }
//                               >
//                                 {t("Proceed")}
//                               </button>
//                             </div>
//                           </Col>
//                         </Row>
//                       </form>
//                     )}
//                   </Formik>
//                 </Col>
//               )}
//               {shoedataaftersave && (
//                 <Col md={8}>
//                   <div class="my-info px-0 shadow-none h-auto">
//                     <ul className="dtl-brder">
//                       <li>
//                         {t("assignment_number")} :{" "}
//                         <span> {dataforShow?.assignmentNo} </span>
//                       </li>
//                       <li>
//                         {t("total_number_of_question")} :{" "}
//                         <span> {dataforShow?.questions?.length} </span>
//                       </li>

//                       <li>
//                         {t("assignment_type")} :{" "}
//                         <span>
//                           {" "}
//                           {assessmentType == "awarenessCourse"
//                             ? "Awareness & Courses"
//                             : assessmentType}{" "}
//                         </span>
//                       </li>

//                       <li>
//                         {t("term")} : <span> {dataforShow?.term} </span>
//                       </li>

//                       <li>
//                         {t("subject")} :{" "}
//                         <span> {dataforShow?.subject?.name} </span>
//                       </li>

//                       {(assessmentType == "lab" ||
//                         assessmentType == "assessment") && (
//                         <li>
//                           {t("total_mark")} :{" "}
//                           <span> {dataforShow?.totalMarks} </span>
//                         </li>
//                       )}
//                     </ul>
//                     <div className="section-add-cmt">
//                       <>
//                         <button
//                           className="btn-btn-faded w-100"
//                           onClick={(e) => {
//                             e.preventDefault();
//                             SaveData("mySelf");
//                           }}
//                         >
//                           {t("my_self")}{" "}
//                         </button>
//                         <button
//                           className="btn-btn-faded w-100"
//                           onClick={(e) => {
//                             e.preventDefault();
//                             SaveData("public");
//                           }}
//                         >
//                           {t("public")}{" "}
//                         </button>
//                       </>
//                     </div>
//                   </div>
//                 </Col>
//               )}
//             </Row>
//           </section>
//         </section>
//       </div>
//       {/* <SelectStarModal
//         show={starmodal}
//         onHide={() => setSlectStarModal(false)}
//         Selectdata={(data) => {
//           SetSelectStar(data);
//         }}
//         prevoiusdata={stararraySelected}
//       /> */}
//     </>
//   );
// };

// export default AddQuestions;

import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Row, Col, Tab, Tabs } from "react-bootstrap";
import moment from "moment";
import { Field, FieldArray, Formik, useFormikContext } from "formik";
import DatePicker from "react-datepicker";
import Clock from "../../assets/img/clock.svg";
import Calendar from "../../assets/img/calendar-color.svg";
import Meeting from "../../assets/img/meetingWith.png";
import Select from "react-select";

import StatusCheck from "../../assets/img/status-check.svg";
import EditIcon from "../../assets/img/edit-icon.svg";
import Question from "../../assets/img/question-mark.svg";
import Ellipse from "../../assets/img/ellipse-1.svg";
import { toast } from "react-toastify";
import ErrorComponent from "../../Component/ErrorComponent";
import DELETE from "../../assets/img/delete-icon.svg";
import ADD from "../../assets/img/add.svg";
import {
  CreateAssignemntSchema,
  Elibrary,
  validationSchemas,
  validationSchemasMul,
} from "../../utils/ValidationSchema";
import SelectStarModal from "../../Component/SelectStar";
import { useEffect } from "react";
import {
  GetFunction,
  SubmitResponse,
  UpdatePutReponse,
  handleimageUrl,
} from "../../utils/ApiFunctions";
import { useLocalization } from "../../Component/Localization/Localization";
import { init } from "emoji-mart";
// import SelectStar from "../Component/SelectStar"

const AddQuestions = () => {
  const { assessmentType, id, assignment, value } = useParams();
  const navigate = useNavigate();
  const [previousQuestions, SetpreviousQuestion] = useState([]);

  const [preview, setImagePreivew] = useState("");
  const [valuesType, setMAinType] = useState("");
  const [dataforShow, setDataForShow] = useState([]);
  const [questions, setQuestions] = useState([]);
  const usr = localStorage.getItem("user_id");

  const [shoedataaftersave, setShowData] = useState(false);
  const [starmodal, setSlectStarModal] = useState([]);
  const [alldata, setAllData] = useState(false);
  const [subType, setSubType] = useState("");
  const [stararraySelected, SetSelectStar] = useState([]);

  const [initialValues1, setIntinalValues1] = useState({
    type: "",
    subtype: "",
    marks: "",
    title: "",
    mediaFile: "",
    description: "",
    answer: "",
    answerOption: "",
    options: ["", "", "", ""],
    mulipleansweroption: [],
  });
  const questionsType = [
    { value: "writtenQuestion", label: "Written Question" },
    { value: "photoWithQuestion", label: "Photo With Question" },
    { value: "videoWithQuestion", label: "Video With Question" },
    { value: "voiceOnly", label: "Voice only" },
    // { value: "match", label: "Match" },
    { value: "multipleChooseOnAnswer", label: "Multiple choose on answer" },
    {
      value: "multipleChooseMoreThanOneCorrectAnswer",
      label: "Multiple choose more than one correct answer",
    },
    { value: "sequenceMultipleChoose", label: "Sequence Multiple Choose" },
    { value: "completeTheSentence", label: "Complete The Sentence" },
    { value: "completeTheWord", label: "Complete The Word" },
  ];

  async function GetDetails() {
    const res = await GetFunction(`assignments/single/${assignment}`);
    if (res.status == 200) {
      setQuestions(res?.data?.data?.questions);
      setDataForShow(res?.data?.data);
    }
  }

  // setQuestiion in array

  useEffect(() => {
    if (questions && questions.length > 0) {
      const firstQuestion = questions?.[0];

      const optionsObj = [
        ...Object.values(questions?.[0]?.option1),
        ...Object.values(questions?.[0]?.option2),
        ...Object.values(questions?.[0]?.option3),
        ...Object.values(questions?.[0].option4),
        ...Object.values(questions?.[0].option5),
        ...Object.values(questions?.[0].option6),
      ];
      setImagePreivew(handleimageUrl(firstQuestion?.mediaFile));

      setIntinalValues1({
        type: firstQuestion?.type,
        subtype: firstQuestion?.subtype,
        marks: firstQuestion?.marks,
        title: firstQuestion?.title,
        mediaFile: firstQuestion?.mediaFile,
        description: firstQuestion?.description,
        answer: firstQuestion?.answer?.text,
        answerOption: firstQuestion?.answer?.option,
        options: optionsObj,
        mulipleansweroption: firstQuestion?.answer?.multiOption,
        id: firstQuestion?._id,
        questionsNo: firstQuestion?.questionNo,
      });

      //   setQuestions((pre) => pre?.splice(0, 1));
    } else {
      setIntinalValues1({
        type: "",
        subtype: "",
        marks: "",
        title: "",
        mediaFile: "",
        description: "",
        answer: "",
        answerOption: "",
        options: ["", "", "", ""],
        mulipleansweroption: [],
      });
    }
  }, [questions]);

  useEffect(() => {
    if (assignment) {
      GetDetails();
    }
  }, [assignment]);

  useEffect(() => {
    if (shoedataaftersave) {
      GetDetails();
    }
  }, [shoedataaftersave]);

  const onSubmitFunction1 = async (values, { resetForm }) => {
    const data = new FormData();
    if (
      values?.type == "voiceOnly" ||
      values?.type == "photoWithQuestion" ||
      values?.type == "videoWithQuestion"
    ) {
      if (values.mediaFile == "") {
        toast.error("Please Select file");
        return;
      }
    }
    if (values?.id) {
      data.append("id", values?.id);
    }
    data.append("assignment", assignment);
    data.append("title", values?.title);
    data.append("description", values?.description);
    // if (assessmentType == "worksheet" || assessmentType == "awarenessCourses" ) {
    //   data.append("marks", 0);
    // } else {
    //   data.append("marks", values?.marks);
    // }
    data.append("marks", values?.marks);
    if (values?.answer) {
      data.append("answer", values?.answer);
    }
    data.append("type", values?.type);
    data.append("subtype", values?.subtype);
    if (values?.mediaFile) {
      if (values.mediaFile instanceof File) {
        data.append("mediaFile", values?.mediaFile);
      }
    }
    if (values?.answerOption) {
      data.append("answerOption", values?.answerOption);
    }
    let Optiosn = [];

    if (
      values?.options &&
      values?.options.every(
        (element) => typeof element === "string" && element !== ""
      )
    ) {
      if (values?.options) {
        for (let i = 0; i < values?.options?.length; i++) {
          data.append(`option${i + 1}`, values?.options[i]);
          // if (values?.mulipleansweroption?.includes(values?.options[i])) {
          //   Optiosn.push(`option${i + 1}`);
          // }
        }
      }
      // Optiosn = Optiosn?.flat();
    }

    // if (Optiosn) {
    //   for (let i = 0; i < Optiosn?.length; i++) {
    //     data.append(`multiOption[${i}]`, Optiosn[i]);
    //   }
    // }
    if (values?.mulipleansweroption) {
      for (let i = 0; i < values?.mulipleansweroption?.length; i++) {
        data.append(`multiOption[${i}]`, values?.mulipleansweroption[i]);
      }
    }

    const res = await SubmitResponse(`/assignments/add_question`, data);
    if (res.status == 200) {
      toast.dismiss();

      toast.success(res?.data?.message);

      if (value == "1") {
        const updatedArray = questions.slice(1);
        setQuestions(updatedArray);
        resetForm();
        SetpreviousQuestion((pre) => [...pre, res?.data?.data]); //for back questiuonas
        setImagePreivew("");
      } else {
        resetForm();
        SetpreviousQuestion((pre) => [...pre, res?.data?.data]); //for back questiuonas
        setImagePreivew("");
        const updatedArray = questions.slice(1);
        setQuestions(updatedArray);
      }
    }
  };

  const onSubmitFunction2 = async (values, { resetForm }) => {
    if (
      values?.type == "voiceOnly" ||
      values?.type == "photoWithQuestion" ||
      values?.type == "videoWithQuestion"
    ) {
      if (values.mediaFile == "") {
        toast.error("Please Select file");
        return;
      }
    }
    const data = new FormData();
    if (value == "1" && values?.id) {
      data.append("id", values?.id);
    }
    data.append("assignment", assignment);
    data.append("title", values?.title);
    data.append("description", values?.description);
    if (assessmentType == "worksheet" || assessmentType == "awarenessCourses") {
      data.append("marks", 0);
    } else {
      data.append("marks", values?.marks);
    }
    if (values?.answer) {
      data.append("answer", values?.answer);
    }
    data.append("type", values?.type);
    data.append("subtype", values?.subtype);
    if (values?.mediaFile) {
      if (values.mediaFile instanceof File) {
        data.append("mediaFile", values?.mediaFile);
      }
    }
    if (values?.answerOption) {
      data.append("answerOption", values?.answerOption);
    }

    // if (
    //   values?.options &&
    //   values?.options.every(
    //     (element) => typeof element === "string" && element !== ""
    //   )
    // ) {
    //   if (values?.options) {
    //     for (let i = 0; i < values?.options?.length; i++) {
    //       data.append(`option${i + 1}`, values?.options[i]);
    //     }
    //   }
    // }

    if (values?.mulipleansweroption) {
      for (let i = 0; i < values?.mulipleansweroption?.length; i++) {
        data.append(`multiOption[${i}]`, values?.mulipleansweroption[i]);
      }
    }

    let Optiosn = [];

    if (
      values?.options &&
      values?.options.every(
        (element) => typeof element === "string" && element !== ""
      )
    ) {
      if (values?.options) {
        for (let i = 0; i < values?.options?.length; i++) {
          data.append(`option${i + 1}`, values?.options[i]);
          // if (values?.mulipleansweroption?.includes(values?.options[i])) {
          //   Optiosn.push(`option${i + 1}`);
          // }
        }
      }
      // Optiosn = Optiosn?.flat();
    }

    // if (Optiosn) {
    //   for (let i = 0; i < Optiosn?.length; i++) {
    //     data.append(`multiOption[${i}]`, Optiosn[i]);
    //   }
    // }

    const res = await SubmitResponse(`/assignments/add_question`, data);
    if (res.status == 200) {
      toast.dismiss();
      setAllData(values);
      setShowData(true);
      toast.success(res?.data?.message);
      setImagePreivew("");
      resetForm();
      // navigate(`/elibrary/${assessmentType}`);
    }
  };

  const onSubmitFunction3 = async () => {
    // getPreviosQuestion and update

    const firstQuestion = previousQuestions[previousQuestions?.length - 1];

    const optionsObj = [
      ...Object.values(firstQuestion?.option1 ? firstQuestion?.option1 : ""),
      ...Object.values(firstQuestion.option2 ? firstQuestion.option2 : ""),
      ...Object.values(firstQuestion.option3 ? firstQuestion.option3 : ""),
      ...Object.values(firstQuestion.option4 ? firstQuestion.option4 : ""),
      ...Object.values(firstQuestion.option5 ? firstQuestion.option5 : ""),
      ...Object.values(firstQuestion.option6 ? firstQuestion.option6 : ""),
    ];
    setImagePreivew(handleimageUrl(firstQuestion?.mediaFile));
    setIntinalValues1({
      type: firstQuestion?.type,
      subtype: firstQuestion?.subtype,
      marks: firstQuestion?.marks,
      title: firstQuestion?.title,
      mediaFile: firstQuestion?.mediaFile,
      description: firstQuestion?.description,
      answer: firstQuestion?.answer?.text,
      answerOption: firstQuestion?.answer?.option,
      options: optionsObj,
      mulipleansweroption: firstQuestion?.answer?.multiOption,
      id: firstQuestion?._id,
    });
    const remaining = previousQuestions.slice(0, -1);
    SetpreviousQuestion(remaining);
  };

  const { t } = useLocalization();
  // for last View

  const SaveData = async (type) => {
    const bools = type == "mySelf" ? false : true;
    const res = await GetFunction(
      `assignments/post/${assignment}?isPost=${bools}`
    );
    if (res.status == 200) {
      toast.dismiss();

      toast.success(res?.data?.message);
      navigate(`/elibrary/${assessmentType}`);
    }
  };

  const subTypeOptions = [
    { value: "", label: `${t("sub_type")}:` },
    ...(valuesType === "writtenQuestion" ||
    valuesType === "photoWithQuestion" ||
    valuesType === "videoWithQuestion" ||
    valuesType === "voiceOnly"
      ? [
          { value: "subjective", label: "Subjective" },
          { value: "objective", label: "Objective" },
          { value: "multipleSelect", label: "MultipleSelect" },
        ]
      : valuesType === "match" || valuesType === "multipleChooseOnAnswer"
      ? [
          { value: "objective", label: "Objective" },
          { value: "multipleSelect", label: "MultipleSelect" },
        ]
      : valuesType === "multipleChooseMoreThanOneCorrectAnswer"
      ? [{ value: "multipleSelect", label: "MultipleSelect" }]
      : valuesType === "sequenceMultipleChoose"
      ? [{ value: "objective", label: "Objective" }]
      : valuesType === "completeTheWord" || valuesType === "completeTheSentence"
      ? [
          { value: "objective", label: "Objective" },
          { value: "subjective", label: "Subjective" },
        ]
      : [
          { value: "objective", label: "Objective" },
          { value: "subjective", label: "Subjective" },
          { value: "multipleSelect", label: "MultipleSelect" },
        ]),
  ];

  return (
    <>
      <div id="main" className="main-section-login">
        <section className="">
          <div className="section-heading plage-steps-dtl my-2">
            <h2 className="performance-heading">
              {id ? t("update_question") : t("add_question")}
              <span></span>
            </h2>
          </div>

          <section className="profile-aection bg-light p-4">
            <Row className="mt-2">
              <div>
                {value == "1" && !shoedataaftersave ? (
                  <span>
                    {initialValues1?.questionsNo
                      ? "Question No:" + initialValues1?.questionsNo
                      : ""}
                  </span>
                ) : (
                  ""
                )}
              </div>
              {!shoedataaftersave && (
                <Col md={8}>
                  <Formik
                    initialValues={initialValues1}
                    onSubmit={(values, { resetForm }) => {
                      if (values.buttonClicked === "saveAndNext") {
                        onSubmitFunction1(values, { resetForm });
                      } else if (values.buttonClicked === "post") {
                        onSubmitFunction2(values, { resetForm });
                      } else if (values.buttonClicked === "PreviousQuestion") {
                        // onSubmitFunction3(values, { resetForm });
                      }
                    }}
                    //   onSubmit={id ? UpdateSubmit : handleSubmit}
                    validationSchema={
                      !value || value == undefined
                        ? subType == "objective" ||
                          (subType == "multipleSelect" && assignment !== "")
                          ? validationSchemasMul
                          : validationSchemas
                        : ""
                    }
                    enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      setFieldValue,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      resetForm,
                    }) => (
                      <form
                        className="cmn-frm without-icon add-filds"
                        onSubmit={handleSubmit}
                      >
                        <Row>
                          <Col md={12}>
                            <div className="form-group upper-index-1">
                              {/* <select
                                onChange={handleChange}
                                value={values.type}
                                name="type"
                              >
                                <option value="" defaultValue>
                                  {t("select_question")}
                                </option>
                                {questionsType &&
                                  questionsType?.map((val, i) => (
                                    <option value={val?.value}>
                                      {val?.name}
                                    </option>
                                  ))}
                              </select> */}

                              <Select
                                placeholder={t("select_question")}
                                options={questionsType}
                                onChange={(option) => {
                                  setMAinType(option.value);
                                  setSubType("");
                                  setFieldValue("mediaFile", "");
                                  setFieldValue("subtype", "");
                                  setImagePreivew("");
                                  handleChange({
                                    target: {
                                      name: "type",
                                      value: option ? option.value : "",
                                    },
                                  });
                                }}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999, // Set the desired z-index value
                                    padding: "5px",
                                  }),
                                  control: (provided) => ({
                                    ...provided,
                                    borderColor: "#AEAEAE", // Set border color to #AEAEAE
                                    "&:hover": {
                                      borderColor: "#AEAEAE", // Set border color when hovering
                                    },
                                    padding: "8px",
                                  }),
                                }}
                                value={questionsType.find(
                                  (option) => option.value === values.type
                                )}
                              />
                            </div>
                            <ErrorComponent
                              error={errors.type && touched.type && errors.type}
                            />
                          </Col>

                          <Col md={12}>
                            <div className="form-group upper-index">
                              {/* <select
                                onChange={(e) => {
                                  handleChange(e);
                                  setSubType(e.target.value);
                                  setFieldValue("mediaFile", "");
                                  setImagePreivew("");
                                }}
                                value={values.subtype}
                                name="subtype"
                              >
                                <option value="" defaultValue>
                                  {t("sub_type")}:
                                </option>

                                {values?.type == "writtenQuestion" ||
                                values?.type == "photoWithQuestion" ||
                                values?.type == "videoWithQuestion" ||
                                values?.type == "voiceOnly" ? (
                                  <>
                                    <option value="subjective">
                                      Subjective
                                    </option>
                                    <option value="objective">Objective</option>
                                    <option value="multipleSelect">
                                      MultipleSelect
                                    </option>
                                  </>
                                ) : values?.type == "match" ||
                                  values?.type == "multipleChooseOnAnswer" ? (
                                  <>
                                    <option value="objective">Objective</option>
                                    <option value="multipleSelect">
                                      MultipleSelect
                                    </option>
                                  </>
                                ) : values?.type ==
                                  "multipleChooseMoreThanOneCorrectAnswer" ? (
                                  <>
                                    <option value="multipleSelect">
                                      MultipleSelect
                                    </option>
                                  </>
                                ) : values?.type == "sequenceMultipleChoose" ? (
                                  <>
                                    <option value="objective">Objective</option>
                                  </>
                                ) : values?.type == "completeTheWord" ||
                                  values?.type == "completeTheSentence" ? (
                                  <>
                                    <option value="objective">Objective</option>
                                    <option value="subjective">
                                      Subjective
                                    </option>
                                  </>
                                ) : (
                                  <>
                                    <option value="objective">Objective</option>
                                    <option value="subjective">
                                      Subjective
                                    </option>
                                    <option value="multipleSelect">
                                      MultipleSelect
                                    </option>
                                  </>
                                )}
                              </select> */}
                              <Select
                                placeholder={t("sub_type")}
                                options={subTypeOptions}
                                onChange={(option) => {
                                  setSubType(option.value);
                                  setFieldValue("mediaFile", "");
                                  setImagePreivew("");
                                  handleChange({
                                    target: {
                                      name: "subtype",
                                      value: option ? option.value : "",
                                    },
                                  });
                                }}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999, // Set the desired z-index value
                                    padding: "5px",
                                  }),
                                  control: (provided) => ({
                                    ...provided,
                                    borderColor: "#AEAEAE", // Set border color to #AEAEAE
                                    "&:hover": {
                                      borderColor: "#AEAEAE", // Set border color when hovering
                                    },
                                    padding: "8px",
                                  }),
                                }}
                                value={subTypeOptions.find(
                                  (option) => option.value === values.subtype
                                )}
                              />
                            </div>
                            <ErrorComponent
                              error={
                                errors.subtype &&
                                touched.subtype &&
                                errors.subtype
                              }
                            />
                          </Col>

                          {
                            // assessmentType != "awarenessCourses" &&
                            //   assessmentType != "worksheet" &&
                            <Col md={12}>
                              <div className="form-group">
                                <input
                                  type="number"
                                  required
                                  name="marks"
                                  placeholder={t("marks")}
                                  onChange={handleChange}
                                  value={values.marks}
                                />
                              </div>
                              <ErrorComponent
                                error={
                                  errors.marks && touched.marks && errors.marks
                                }
                              />
                            </Col>
                          }

                          <Col md={12}>
                            <div className="form-group">
                              <input
                                type="text"
                                name="title"
                                placeholder={t("title")}
                                onChange={handleChange}
                                value={values.title}
                              />
                            </div>
                            <ErrorComponent
                              error={
                                errors.title && touched.title && errors.title
                              }
                            />
                          </Col>

                          {(values?.subtype == "multipleSelect" ||
                            values?.subtype == "objective") && (
                            <FieldArray name="options ">
                              {({ push, remove }) => (
                                <div>
                                  {values.options.map((item, index) => (
                                    <>
                                      <div
                                        key={index}
                                        className="d-flex mt-2 mb-2"
                                      >
                                        <Field
                                          name={`options[${index}]`}
                                          placeholder={`Enter option ${
                                            index + 1
                                          }`}
                                        />
                                        {}

                                        {values?.options?.length > 2 && (
                                          <button
                                            className="form-delete-btn mx-2"
                                            type="button"
                                          >
                                            <img
                                              src={DELETE}
                                              onClick={() => {
                                                // remove(index);
                                                const newOptions = [
                                                  ...values.options,
                                                ]; // Create a copy of the array
                                                newOptions.splice(index, 1); // Remove the item at the specified index
                                                setFieldValue(
                                                  "options",
                                                  newOptions
                                                );
                                              }}
                                            />
                                          </button>
                                        )}
                                      </div>
                                      <ErrorComponent
                                        error={
                                          errors.options &&
                                          touched.options?.[index] &&
                                          errors.options?.[index]
                                        }
                                      />
                                    </>
                                  ))}

                                  {values?.options?.length < 6 && (
                                    <button
                                      type="button"
                                      className="form-delete-btn"
                                      // onClick={() => push("")}//
                                    >
                                      <img
                                        src={ADD}
                                        onClick={() => {
                                          const newOptions = [
                                            ...values.options,
                                          ]; // Create a copy of the array
                                          newOptions.push(""); // Remove the item at the specified index
                                          setFieldValue("options", newOptions);
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                              )}
                            </FieldArray>
                          )}

                          {values?.type == "photoWithQuestion" ||
                          values?.type == "voiceOnly" ||
                          values?.type == "videoWithQuestion" ? (
                            <Col md={12}>
                              <div
                                className={
                                  values?.type == "voiceOnly"
                                    ? "form-group voice"
                                    : "form-group"
                                }
                              >
                                <input
                                  type="file"
                                  className="upload-img"
                                  // required
                                  onChange={(e) => {
                                    if (values.type == "photoWithQuestion") {
                                      if (
                                        e.target.files[0]?.type.startsWith(
                                          "image"
                                        )
                                      ) {
                                        setFieldValue(
                                          "mediaFile",
                                          e.target.files[0]
                                        );
                                        setImagePreivew(
                                          URL.createObjectURL(e.target.files[0])
                                        );
                                      } else {
                                        toast.error(
                                          "Please Select Image In Photo Type Question"
                                        );
                                      }
                                    }

                                    if (values.type == "voiceOnly") {
                                      if (
                                        e.target.files[0]?.type.startsWith(
                                          "audio"
                                        )
                                      ) {
                                        setFieldValue(
                                          "mediaFile",
                                          e.target.files[0]
                                        );
                                        setImagePreivew(
                                          URL.createObjectURL(e.target.files[0])
                                        );
                                      } else {
                                        toast.error(
                                          "Please Select Audio File In Voice Type Question"
                                        );
                                      }
                                    }

                                    if (values.type == "videoWithQuestion") {
                                      if (
                                        e.target.files[0]?.type.startsWith(
                                          "video"
                                        )
                                      ) {
                                        setFieldValue(
                                          "mediaFile",
                                          e.target.files[0]
                                        );
                                        setImagePreivew(
                                          URL.createObjectURL(e.target.files[0])
                                        );
                                      } else {
                                        toast.error(
                                          "Please Select video In Video Type Question"
                                        );
                                      }
                                    }
                                  }}
                                />
                              </div>

                              <ErrorComponent
                                error={
                                  errors.mediaFile &&
                                  touched.mediaFile &&
                                  errors.mediaFile
                                }
                              />
                              {preview !== "" && (
                                <div className="delete-icon-image">
                                  {values.type == "photoWithQuestion" ? (
                                    <img src={preview} className="img-fluid" />
                                  ) : (
                                    <iframe
                                      width="560"
                                      height="315"
                                      frameBorder="0"
                                      allowFullScreen
                                      src={preview}
                                      className="img-fluid"
                                    />
                                  )}
                                  <div
                                    className={
                                      values.type == "photoWithQuestion"
                                        ? "delete-ic cursors"
                                        : "delete-icon cursors"
                                    }
                                  >
                                    <img
                                      src={DELETE}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setFieldValue("mediaFile", "");
                                        setImagePreivew("");
                                      }}
                                    />
                                  </div>
                                </div>
                              )}

                              <span className="d-flex gap-2 text-size-small">
                                <strong>Supported file type :</strong>{" "}
                                <p>mp3, mp4, jpg, jpeg & png</p>
                              </span>
                            </Col>
                          ) : (
                            ""
                          )}

                          <Col md={12}>
                            <div className="form-group">
                              <textarea
                                className="form-control"
                                onChange={handleChange}
                                name="description"
                                value={values?.description}
                                placeholder={t("description")}
                                rows={5}
                              />
                            </div>
                            <ErrorComponent
                              error={
                                errors.description &&
                                touched.description &&
                                errors.description
                              }
                            />
                          </Col>

                          {values?.subtype == "subjective" ? (
                            <Col md={12}>
                              <div className="form-group">
                                <input
                                  type="text"
                                  name="answer"
                                  placeholder="Answer"
                                  onChange={handleChange}
                                  value={values.answer}
                                  required
                                />
                              </div>
                              <ErrorComponent
                                error={
                                  errors.answer &&
                                  touched.answer &&
                                  errors.answer
                                }
                              />
                            </Col>
                          ) : values?.subtype == "objective" ? (
                            <>
                              <div className="form-group">
                                <select
                                  onChange={handleChange}
                                  value={values.answerOption}
                                  name="answerOption"
                                >
                                  <option value="" defaultValue>
                                    Select Answer
                                  </option>
                                  {values?.options &&
                                    values?.options?.map((val, i) => (
                                      <option value={`option${[i + 1]}`}>
                                        {val}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <ErrorComponent
                                error={
                                  errors.answerOption &&
                                  touched.answerOption &&
                                  errors.answerOption
                                }
                              />
                            </>
                          ) : values?.subtype == "multipleSelect" &&
                            values?.options.every(
                              (element) =>
                                typeof element === "string" && element !== ""
                            ) ? (
                            <>
                              <div className="muliple answer">
                                <h5>{t("select_multiple_answer")}</h5>
                                <FieldArray name="mulipleansweroption">
                                  {({ push, remove }) => (
                                    <div>
                                      {values?.options?.map((option, index) => (
                                        <div key={index}>
                                          <label>
                                            <Field
                                              type="checkbox"
                                              name={`mulipleansweroption[${
                                                index + 1
                                              }]`}
                                              value={option}
                                              checked={values?.mulipleansweroption?.includes(
                                                `option${index + 1}`
                                              )}
                                              // onChange={(e) => {
                                              //   const { value, checked } =
                                              //     e.target;

                                              //   if (checked) {
                                              //     push(value);
                                              //   } else {
                                              //     const idx =
                                              //       values.mulipleansweroption.indexOf(
                                              //         value
                                              //       );
                                              //     if (idx !== -1) {
                                              //       remove(idx);
                                              //     }
                                              //   }
                                              // }}

                                              onChange={(e) => {
                                                const { value, checked } =
                                                  e.target;

                                                if (checked) {
                                                  // push(value);
                                                  push(`option${index + 1}`);
                                                } else {
                                                  const idx =
                                                    values?.mulipleansweroption?.findIndex(
                                                      // (item) => item == value
                                                      (item) =>
                                                        item ==
                                                        `option${index + 1}`
                                                      // `option${index + 1}`
                                                    );
                                                  if (idx !== -1) {
                                                    remove(idx);
                                                  }
                                                }
                                              }}
                                            />
                                            {option}
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </FieldArray>
                                <ErrorComponent
                                  error={
                                    errors.mulipleansweroption &&
                                    touched.mulipleansweroption &&
                                    errors.mulipleansweroption
                                  }
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}

                          {previousQuestions.length > 0 && (
                           <Col md={4} className="mt-3">
                              <div>
                                <button
                                  className="btn-btn-primary px-3 w-100 text-nowrap"
                                  type="button"
                                  onClick={() => onSubmitFunction3()}
                                >
                                  {t("PreviousQuestion")}
                                </button>
                              </div>
                            </Col>
                          )}
                         <Col md={4} className="mt-3">
                            <div>
                              <button
                                className="btn-btn-primary px-3 w-100 text-nowrap"
                                type="submit"
                                onClick={() =>
                                  setFieldValue("buttonClicked", "saveAndNext")
                                }
                              >
                                {t("save_next")}
                              </button>
                            </div>
                          </Col>

                          <Col md={4} className="mt-3">
                            <div>
                              <button
                                className={
                                  previousQuestions?.length > 0
                                    ? "btn-btn-primary px-5 w-100"
                                    : "btn-btn-primary px-5 w-100"
                                }
                                type="submit"
                                onClick={() =>
                                  setFieldValue("buttonClicked", "post")
                                }
                              >
                                {t("Proceed")}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    )}
                  </Formik>
                </Col>
              )}
              {shoedataaftersave && (
                <Col md={8}>
                  <div class="my-info px-0 shadow-none h-auto">
                    <ul className="dtl-brder">
                      <li>
                        {t("assignment_number")} :{" "}
                        <span> {dataforShow?.assignmentNo} </span>
                      </li>
                      <li>
                        {t("total_number_of_question")} :{" "}
                        <span> {dataforShow?.questions?.length} </span>
                      </li>

                      <li>
                        {t("assignment_type")} :{" "}
                        <span>
                          {" "}
                          {assessmentType == "awarenessCourse"
                            ? "Awareness & Courses"
                            : assessmentType}{" "}
                        </span>
                      </li>

                      <li>
                        {t("term")} : <span> {dataforShow?.term} </span>
                      </li>

                      <li>
                        {t("subject")} :{" "}
                        <span> {dataforShow?.subject?.name} </span>
                      </li>

                      {(assessmentType == "lab" ||
                        assessmentType == "assessment") && (
                        <li>
                          {t("total_mark")} :{" "}
                          <span> {dataforShow?.totalMarks} </span>
                        </li>
                      )}
                    </ul>
                    <div className="section-add-cmt">
                      <>
                        <button
                          className="btn-btn-faded w-100"
                          onClick={(e) => {
                            e.preventDefault();
                            SaveData("mySelf");
                          }}
                        >
                          {t("my_self")}{" "}
                        </button>
                        <button
                          className="btn-btn-faded w-100"
                          onClick={(e) => {
                            e.preventDefault();
                            SaveData("public");
                          }}
                        >
                          {t("public")}{" "}
                        </button>
                      </>
                    </div>
                  </div>
                </Col>
              )}
            </Row>
          </section>
        </section>
      </div>
      {/* <SelectStarModal
        show={starmodal}
        onHide={() => setSlectStarModal(false)}
        Selectdata={(data) => {
          SetSelectStar(data);
        }}
        prevoiusdata={stararraySelected}
      /> */}
    </>
  );
};

export default AddQuestions;
